import React from 'react'
import { useTranslation } from 'react-i18next'
import { Avatar, DataListItem, InfoCard } from '@node-space/ui-components'

interface ContactCardProps {
  name: string
  showAvatar?: boolean
  title?: string
}

export const ContactCard = ({ name, showAvatar = true, title = '' }: ContactCardProps) => {
  const { t } = useTranslation()

  return (
    <InfoCard>
      <DataListItem
        layout="vertical"
        id="contact-card"
        title={title ?? t('contacts.cryptoContact')}
        BodyAvatar={showAvatar && <Avatar size="small" type="entity" name={name ?? ''} />}
        body={name}
      />
    </InfoCard>
  )
}
